// extracted by mini-css-extract-plugin
module.exports = {"root":"Empty_root__1nWQP","container":"Empty_container__2OTUl","icon":"Empty_icon__38k2P","label":"Empty_label__3xLhi"};